/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 提交报名信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  memberRequest: cms.ApplyActivityMemberRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/save/apply-activity/registered`,
    data: memberRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
